import { useEffect, type ReactNode } from "react";
import { useStore, type AnyFormApi } from "@tanstack/react-form";
import { Form } from "../../../components/Form";
import type { RestCreatePaymentMethod } from "@KassaroAB/shared/types/paymentMethods/paymentMethod";
import type { PaymentMethodId } from "@KassaroAB/shared/types/ids";
import type { RestStore } from "@KassaroAB/shared/types/store";

export type PaymentMethodFormProps<PaymentMethod> = {
  formId: string;
  store: RestStore;
  paymentMethod: PaymentMethod;
  paymentMethodId?: PaymentMethodId;
  savedTick?: number;
  onSubmit: (paymentMethod: RestCreatePaymentMethod) => void;
  onDirtyChange?: (isDirty: boolean) => void;
};

type PaymentMethodFormContainerProps = {
  formId: string;
  form: AnyFormApi;
  savedTick?: number;
  onDirtyChange?: (isDirty: boolean) => void;
  children: ReactNode;
};

export const PaymentMethodFormContainer = ({
  formId,
  form,
  savedTick,
  onDirtyChange,
  children,
}: PaymentMethodFormContainerProps) => {
  const isDirty = useStore(form.store, (state) => !state.isDefaultValue);

  useEffect(() => {
    onDirtyChange?.(isDirty);
    return () => onDirtyChange?.(false);
  }, [isDirty, onDirtyChange]);

  useEffect(() => {
    if (!savedTick) return;
    form.reset(form.state.values);
  }, [savedTick, form]);

  return (
    <Form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        form.handleSubmit();
      }}
    >
      {children}
    </Form>
  );
};
